export enum CreditCardType {
  Visa = 'visa',
  Mastercard = 'mastercard',
  DinersClub = 'diners_club',
  AmericanExpress = 'american_express',
  Discover = 'discover',
  JCB = 'jcb',
  BCMC = 'bcmc',
  Maestro = 'maestro',
  CartesBancaires = 'cartes_bancaires',
  Unknown = 'unknown',
}

export enum DisplayedCardBrandName {
  JCB = 'JCB',
  Visa = 'Visa',

  // BCMC has to be displayed as Mastercard
  BCMC = 'Mastercard',
  Mastercard = 'Mastercard',

  DinersClub = 'Diners Club',
  AmericanExpress = 'American Express',
  CartesBancaires = 'Cartes Bancaires',

  Unknown = 'Unknown',
}

export enum CreditCardRequiredField {
  PostalCode = 'postal_code',
}

export enum CreditCardAddReturnResult {
  Success = 'success',
  Fail = 'fail',
}

export enum CreditCardAddSourceEntityType {
  SingleCheckout = 'single_checkout',
  PaymentSettings = 'payment_settings',
}

export enum CreditCardFormLocation {
  Checkout = 'checkout',
  Settings = 'settings',
}

export const CreditCardEntityTypeMap = {
  [CreditCardFormLocation.Checkout]: CreditCardAddSourceEntityType.SingleCheckout,
  [CreditCardFormLocation.Settings]: CreditCardAddSourceEntityType.PaymentSettings,
}

export enum CreditCardAddSdkType {
  Authorization = 'authorization',
  Tokenization = 'tokenization',
}
